<mat-toolbar>
  <div style="width: 100%; text-align: center">
    <a href="/tng">
      <img src="assets/logo-minimal.svg" style="height: 1.2em; margin-top: 20px"/>
    </a>
  </div>
</mat-toolbar>

<div class="wrapper">
  <div class="background-img top-right-rectangle"></div>
  <div class="content">
    <div class="text-center">
      <h1 class="blue">Ihre Einladung <ng-container *ngIf="($tenant | async) as tenant">für {{tenant.name}}</ng-container></h1>
      <br/>
      <strong>Geben Sie Ihren persönlichen Code ein, um die Einladung zu bestätigen.</strong><br/>
      <strong *ngIf="codeViaSms">Der Code wurde Ihnen gerade per SMS zugeschickt.</strong>
      <br/>
      <br/>
      <ng-container [ngSwitch]="invitationStatus">
        <div *ngSwitchCase="'WAITING_FOR_TWO_FACTOR_CODE'">
          <form (submit)="confirmTwoFactorCode()">
            <mat-form-field (submit)="confirmTwoFactorCode()">
              <mat-label>Code</mat-label>
              <mat-hint>z.B. 667788</mat-hint>
              <mat-error *ngIf="twoFactorFormControl.hasError('invalid')">Ungültiger Code</mat-error>
              <input matInput name="twoFactorCode" [formControl]="twoFactorFormControl" appOnlyNumber/>
            </mat-form-field>
            &nbsp;&nbsp;
            <button mat-flat-button color="primary" [disabled]="!twoFactorFormControl.valid || patchingCode">
              <mat-spinner diameter="16" style="display: inline-block" *ngIf="patchingCode"></mat-spinner> Bestätigen</button>
          </form>
        </div>
        <div *ngSwitchCase="'SUCCESS'">
          Ihre Einladung wurde erfolgreich bestätigt. Sie werden weitergeleitet ...
          <br/>
          <br/>
          <mat-spinner style="margin:auto"></mat-spinner>
          <br/>
          <br/>
          <a [routerLink]="['lead-form']">Falls Sie nicht automatisch weitergeleitet werden, klicken Sie bitte hier</a>
        </div>
        <div *ngSwitchCase="'INVALIDATED'">
          Dieser Einladungslink ist nicht mehr gültig. Bitte wenden Sie sich an
        </div>
        <div *ngSwitchCase="'USED'">
          Dieser Einladungslink wurde bereits benutzt. Bitte wenden Sie sich an
        </div>
        <div *ngSwitchCase="'EXPIRED'">
          Dieser Einladungslink ist abgelaufen. Bitte wenden Sie sich an
        </div>
        <div *ngSwitchCase="'INTERNAL_ERROR'">
          Es ist ein unbekannter Fehler aufgetreten
        </div>
        <div *ngSwitchCase="'UNAUTHORIZED'">
          Sie müssen eingeloggt sein, um diese Seite aufrufen zu können.
        </div>
        <div *ngSwitchDefault>
          Unbekannter Status: {{invitationStatus}}
        </div>
      </ng-container>
      <div *ngIf="errorCode">
        Fehlercode: {{errorCode}}
      </div>

      <div *ngIf="invitationStatus !== 'SUCCESS'">
        <br/>
        <br/>
        <span style="font-size: large">Ihr Kontakt bei Dr. Klein</span>
      </div>
    </div>
  </div>
  <div class="display-flex-center margin-top-bottom-3" >
    <div class="info-box">
      <div class="info-image">
        <img src="assets/support.svg" style="height: 112px;"/>
      </div>
      <div class="info-text">
        <h1 class="black">Dr. Klein B2B-Support</h1>
        <h4>First Level Support</h4>
        <table>
          <tr>
            <td>
              <mat-icon color="primary" style="vertical-align: middle; margin-right: 15px">location_on</mat-icon>
            </td>
            <td>
              Hansestraße 14 <br/>
              23558 Lübeck
            </td>
          </tr>
          <tr>
            <td>
              <mat-icon color="primary" style="vertical-align: middle">mail</mat-icon>
            </td>
            <td>
              <a href="mailto:plattform-support@drklein.de">plattform-support@drklein.de</a>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div class="background-img bottom-left-rectangle"></div>
  <div class="background-img bottom-right-rectangle"></div>
</div>
<div class="footer">
  <a href="https://www.drklein.de/datenschutz.html">Datenschutz</a>
  &nbsp;·&nbsp;
  <a href="https://www.drklein.de/agb.html">AGB</a>
  &nbsp;·&nbsp;
  <a href="https://www.drklein.de/impressum.html">Impressum</a>
</div>
